import {
  DollarSignMd,
  FilterMd,
  LocationMd,
  spacingHelper,
  mediaHelper,
} from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import { useCallback } from 'react';
import styled from 'styled-components';
import { useSearchLandingPageModalContext } from '../../contexts/SearchLandingPageModalContext/SearchLandingPageModalContext';
import { trackSearchRefinementModalOpen } from '../../../analytics/event-tracking/trackSearchRefinementModalOpen';
import { useSearchLandingPageContext } from '../../contexts/SearchLandingPageContext/SearchLandingPageContext';
import { SearchRefinementButton } from './subcomponents/SearchRefinementButton';
import { getSearchPageViewFromURL } from '../../../helpers/queryStringHelpers/getSearchPageViewFromURL';

const SearchRefinementButtons = styled.div`
  display: flex;
  gap: ${spacingHelper('extraSmall')};
  ${mediaHelper('mobile')} {
    justify-content: space-between;
  }
`;

const BudgetModalButton = styled(SearchRefinementButton)`
  .search-refinement-button-label {
    margin-left: ${spacingHelper('twoExtraSmall')};
  }
`;

export const SearchLandingPageHeaderButtons: FunctionComponent = () => {
  const {
    activeFilters: { activeLocationFilters, activePropertyFilters, activeBudgetFilters },
    searchQuery,
  } = useSearchLandingPageContext();
  const searchView = getSearchPageViewFromURL(searchQuery);
  const { displayModal } = useSearchLandingPageModalContext();
  const openModal = useCallback(
    (modalType: 'location' | 'propertyConfig' | 'budgetModal') => {
      displayModal(modalType);
      trackSearchRefinementModalOpen(modalType);
    },
    [displayModal],
  );
  return (
    <SearchRefinementButtons>
      <SearchRefinementButton
        activeFilters={activeLocationFilters}
        icon={<LocationMd />}
        onClick={() => {
          openModal('location');
        }}
        searchView={searchView}
      >
        Location
      </SearchRefinementButton>
      <SearchRefinementButton
        activeFilters={activePropertyFilters}
        icon={<FilterMd />}
        onClick={() => openModal('propertyConfig')}
        searchView={searchView}
      >
        Filters
      </SearchRefinementButton>
      <BudgetModalButton
        activeFilters={activeBudgetFilters}
        icon={<DollarSignMd />}
        onClick={() => openModal('budgetModal')}
        className="budget-modal-button"
        searchView={searchView}
      >
        Price
      </BudgetModalButton>
    </SearchRefinementButtons>
  );
};
